$(document).ready(function(){ // -- mapboxFunc is a global var called in lineup.js --
	if ($('#map').length) {

		// -- Browser support --
    if (!mapboxgl.supported()) {
    	
    	// -- WebGL no support --
      $('#map').addClass('no-support');
      $('.mapbox_no_support').fadeIn();

    } else {
    	
    	// -- WebGL supported --
			// -- Token --
			mapboxgl.accessToken = 'pk.eyJ1IjoiZXZlcnl0aGluZ2lzZnVuIiwiYSI6IkVkalZJRUkifQ.i_Taxju9f5wO9aUyOF7Gyg';

			// -- Init map bounds --
			var bounds = new mapboxgl.LngLatBounds();

			// -- Init map --
			var map = new mapboxgl.Map({
			  container: 'map',
			  style: 'mapbox://styles/mapbox/light-v10',
			  center: [6, 49.76],
			  zoom: 5
			});


      map.on('load', function() {
				
				// -- Add sources --
				map.addSource('citiesSrc', {
				  type: 'geojson', 
				  data: geojson,
				});			


				// -- Add a cantons layer (without cluster) --
				map.addLayer({
				  "id": "unclustered-point",
				  "type": "symbol",
				  "source": "citiesSrc",
				  "filter": ["!has", "point_count"],
				  "layout": {
				    "text-field": "{name}",
				    "text-anchor": "top",
				    "text-size": 12,
				    "text-offset": [0,1],
				    "icon-allow-overlap": true
				  },
				  "paint": {
				    "text-color": '#694DB2',
				  },
				});


        // -- Loop geojson data --
				geojson.features.forEach(function(feature) {

					// -- Add markers to bounds --
			    bounds.extend(feature.geometry.coordinates);

				  // -- Create a HTML element for each feature --
				  var city = feature.properties.name.toLowerCase();
				  if (city.indexOf('-') > -1){
				  	city = city.replace(/\s/g, '');
				  } else {
				  	city = city.replace(/\s/g,'-');
				  }

				  // -- Create popup --
					const popup = new mapboxgl.Popup({ offset: 25 }).setHTML(
		        `<h2><a href="${feature.properties.url}" target="_blank" rel="noopener noreferrer" onclick="var otherWindow = window.open(); otherWindow.opener = null; otherWindow.location = href; return false;">${feature.properties.name}</a></h2><ul><li><strong>Date(s) : </strong><span>${feature.properties.dates}</span></li><li><strong>Lieux : </strong><span>${truncate(feature.properties.places)}</span></li><li><strong>Heures : </strong><span>${feature.properties.hours}</span></li><li><strong>Genre : </strong><span>${truncate(feature.properties.genre)}</span></li><a href="${feature.properties.url}" target="_blank" rel="noopener noreferrer" onclick="var otherWindow = window.open(); otherWindow.opener = null; otherWindow.location = href; return false;" class="cta">En savoir plus</a>`
		      );

				  // -- Create markers --
				  const el = document.createElement('div');
				  el.className = 'marker btn--marker' + ' cat--' + city;
					el.setAttribute('data-id',`entryId--${feature.properties.id}`);

				  // -- Add custom marker with popup to the map --
				  const marker = new mapboxgl.Marker(el)
				    .setLngLat(feature.geometry.coordinates)
						.setPopup(popup)	    
				    .addTo(map);

					// -- action : click on marker --
					marker.getElement().addEventListener('click', (e) => { 
						if (marker.getElement().classList.contains('active') == false) {
							highlightFeatureOff();
							popup.addTo(map);
							marker.getElement().classList.toggle('active');
							document.getElementById(marker.getElement().getAttribute('data-id')).classList.toggle('active');
							map.flyTo({
								center: marker._lngLat,
								// zoom: 12,
								essential: true
							});

						} else {
							highlightFeatureOff();
						}
						e.stopPropagation();
					}, false);				    

				});


				// -- Fit map to marker --
				map.fitBounds(bounds,{padding:60});

				// -- action : click on show on map --
				$(document).on('click', '.btn--showOnMap', function(e){
					var id = $(this).attr('id');
					$(`.marker[data-id="${id}"]`).click();
				});

				// -- action : click on map --
				map.on('click', function(e){
					highlightFeatureOff();
				});

      });

			// -- functions > desactive highlighted feature --
			const highlightFeatureOff = function(){
				const showOnMapBtn = document.querySelectorAll('.btn--showOnMap');
				const markers = document.querySelectorAll('.marker');
			 	const popup = document.getElementsByClassName('mapboxgl-popup');
			 	// -- desactive markers & showOnMapBtn --
			  for (var i = 0; i < markers.length; i++) {
			    markers[i].classList.remove('active');
			    showOnMapBtn[i].classList.remove('active');
			  }
			 	// -- desactive popup --
				if (popup.length) {
			    popup[0].remove();
				}
			}

			const truncate = function(str, length = 80, ending = '…') {
				if (str.length > length) {
					return str.substring(0, length - ending.length) + ending;
				} else {
					return str;
				}
			};
    }

	}
});